<template>
  <div class="sampleCalculation">
    <table>
      <tr>
        <th style="width:100px;">순번</th>
        <th>수량</th>
        <th>단가</th>
        <th>공급가</th>
        <th>세액</th>
      </tr>
      <tr v-for="(n,index) in 10" :key="index">
        <td>{{index+1}}</td>
        <td>
          <el-input
            v-model="list[index].amount"
            :id="'amount'+index"
            @input="calculation(index),total(10,'totalPrice','totalSupplyPrice','totalTax')"
          ></el-input>
        </td>
        <td>
          <el-input
            v-model="list[index].unitPrice"
            :id="'unitPrice'+index"
            v-comma
            @input="calculation(index),total(10,'totalPrice','totalSupplyPrice','totalTax')"
          ></el-input>
        </td>
        <td>
          <el-input v-model="list[index].supplyPrice" readonly :id="'supplyPrice'+index" v-comma></el-input>
        </td>
        <td>
          <el-input v-model="list[index].tax" readonly :id="'tax'+index" v-comma></el-input>
        </td>
      </tr>
      <tr>
        <td colspan="3" style="text-align:center;">
          합계: {{totalPrice}}
          <br />
          ( {{totalPrice | numberToKorean}} )
        </td>
        <td>
          <el-input v-comma v-model="totalSupplyPrice" id="totalSupplyPrice" readonly></el-input>
        </td>
        <td>
          <el-input v-comma v-model="totalTax" id="totalTax" readonly></el-input>
        </td>
        <input type="hidden" v-comma v-model="totalPrice" id="totalPrice" readonly />
      </tr>
    </table>
  </div>
</template>


<script>
import * as calc from "../common/function/calculation";

var data = function(
  seq,
  amount = "",
  unitPrice = "",
  supplyPrice = "",
  tax = "",
  price = ""
) {
  this.seq = seq;
  this.amount = amount;
  this.unitPrice = unitPrice;
  this.supplyPrice = supplyPrice;
  this.tax = tax;
  this.price = price;
};
export default {
  name: "sampleCalculation",
  data() {
    return {
      list: [],
      totalPrice: 0,
      totalSupplyPrice: 0,
      totalTax: 0
    };
  },
  created() {
    this.init();
  },
  methods: {
    calculation(index) {
      return calc.default.calculation(
        index,
        "amount",
        "unitPrice",
        "supplyPrice",
        "tax"
      );
    },
    total(index, totalPriceId, totalSupplyPriceID, totalTaxID) {
      return calc.default.total(
        index,
        totalPriceId,
        totalSupplyPriceID,
        totalTaxID
      );
    },
    init() {
      for (let i = 0; i < 10; i++) {
        this.list.push(new data());
      }
    }
  }
};
</script>